<template>
  <div>
    <b-overlay
      class="generalLoading"
      :show="showOverlay"
      rounded="sm"
      z-index="9999"
    >
      <template #overlay>
        <div class="d-flex flex-column align-items-center">
          <b-spinner
            variant="success"
            label="Carregando"
            style="width: 5rem; height: 5rem; font-size: x-large"
          >
          </b-spinner>
          <span class="mt-3 font-weight-bolder" style="font-size: 20px"
            >Carregando...</span
          >
        </div>
      </template>
      <termo-aceitacao-modal-component />
      <div v-if="hasToken">
        <div id="headerwrapper">
          <base-header />
        </div>
        <div class="main-container" :style="cssVars.contentHeight">
          <base-menu />
          <div class="content">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { store, getToken, refreshToken, startInactivityWatcher, stopInactivityWatcher } from "@/store";
import BaseHeader from "@/components/header/base-header.vue";
import BaseMenu from "@/components/menu/base-menu.vue";
import TermoAceitacaoModalComponent from "@/components/termo-aceitacao-modal.vue";
import AlertCP from "@/components/AlertCP.vue";
import suspensaoAdvogadoService from "@/services/suspensaoAdvogadoService";
import { UtilsTS } from "@/utilsts";
export default {
  name: "LayoutComponent",
  components: {
    BaseHeader,
    BaseMenu,
    TermoAceitacaoModalComponent,
  },
  mixins: [UtilsTS],
  data() {
    return {
      contentHeight: 0,
    };
  },
  computed: {
    cssVars() {
      return {
        contentHeight: { "--contentHeight": this.contentHeight },
      };
    },
    hasToken() {
      return store.token !== false && store.cpf !== "";
    },
    showOverlay() {
      return store.blockScreen || store.forceQuit;
    },
  },
  methods: {
    async carregarSuspensoesAdv() {
      const existeSuspensaoResponse =
        await suspensaoAdvogadoService.existeSuspensaoVigente();
      if (existeSuspensaoResponse && existeSuspensaoResponse.status == 200) {
        if (existeSuspensaoResponse.data.existeSuspensao) {
          const { DtInicioSuspensao, DtFimSuspensao } =
            existeSuspensaoResponse.data.suspensaoAdvogado;
          const msg = `Existe uma suspensão cadastrada pela OAB para este usuário. O período da suspensão é de ${this.formatData(
            DtInicioSuspensao
          )} até ${
            DtFimSuspensao ? this.formatData(DtFimSuspensao) : "-"
          }. Para mais detalhes, entre em contato com a OAB.`;
          this.$toast.error(msg, {
            timeout: 20000,
          });
        }
      } else {
        this.$toast.error("Erro ao buscar suspensões");
      }
    },
    async montarAlertaCP() {
      const cpAlertData = await this.loadCPAlert();
      if (cpAlertData && cpAlertData.mostrarAlertaCP) {
        this.$toast.error(
          <AlertCP
            diligenciasNaoLidas={cpAlertData.qtdDiligenciasNaoLidas}
            diligenciasNaoRespondidas={cpAlertData.qtdDiligenciasNaoRespondidas}
            citacoesNaoLidas={cpAlertData.qtdCitacoesNaoLidas}
            citacoesNaoRespondidas={cpAlertData.qtdCitacoesNaoRespondidas}
            avisosNaoLidos={cpAlertData.qtdAvisos}
            assinaturasPendentes={cpAlertData.qtdSolicitacoesAssinatura}
            intimacoesNaoLidas={cpAlertData.qtdIntimacoesNaoLidas}
            intimacoesNaoRespondidas={cpAlertData.qtdIntimacoesNaoRespondidas}
            avisosComRespostaNaoLidas={cpAlertData.qtdAvisosComRespostaNaoLidas}
            avisosComRespostaNaoRespondidas={
              cpAlertData.qtdAvisosComRespostaNaoRespondidas
            }
            oficiosNaoLidas={cpAlertData.qtdOficiosNaoLidas}
            oficiosNaoRespondidas={cpAlertData.qtdOficiosNaoRespondidas}
            determinacoesNaoLidas={cpAlertData.qtdDeterminacoesNaoLidas}
            determinacoesNaoRespondidas={
              cpAlertData.qtdDeterminacoesNaoRespondidas
            }
            tagsNaoLidas={cpAlertData.qtdTermosDeAjustamentoDeGestaoNaoLidas}
            tagsNaoRespondidas={
              cpAlertData.qtdTermosDeAjustamentoDeGestaoNaoRespondidas
            }
            cautelaresNaoLidas={cpAlertData.qtdCautelaresNaoLidas}
            cautelaresNaoRespondidas={cpAlertData.qtdCautelaresNaoRespondidas}
          />,
          {
            timeout: 20000,
          }
        );
      }
    },
    onResize() {
      if (document.getElementById("headerwrapper")) {
        this.contentHeight =
          window.innerHeight - this.getAbsoluteHeight("#headerwrapper") + "px";
      }
    },
  },
  async mounted() {
    window.addEventListener("resize", this.onResize);
    getToken();
    await refreshToken();
    startInactivityWatcher();
    this.carregarSuspensoesAdv();
    this.montarAlertaCP();
    this.onResize();
  },
  beforeDestroy() {
    stopInactivityWatcher();
  },
};
</script>
<style>
#headerwrapper {
  border-bottom: var(--baseColor) solid 4px;
  min-height: 120px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin: 0 !important;
  padding: 0 !important;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(226, 226, 226, 1) 33%,
    rgba(255, 255, 255, 1) 60%,
    rgba(254, 254, 254, 1) 70%,
    rgba(255, 255, 255, 1) 100%
  );
}

.main-container {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: var(--contentHeight) !important;
}

.content {
  background-color: #fff;
  flex: 1;
  margin-right: 0rem !important;
}

@media screen and (max-width: 992px) {
  .main-container {
    display: block;
    width: 100%;
    min-height: var(--contentHeight) !important;
  }

  .content {
    background-color: #fff;
    margin-left: 50px !important;
  }
}

/* -----  */
.block-container {
  display: block;
  width: 100%;
  min-height: var(--contentHeight) !important;
}

.content {
  background-color: #fff;
  margin-left: 0px;
  padding: 5px;
}

.menu {
  background-color: #888;
  width: 250px;
}

.b-overlay.generalLoading {
  height: 100vh;
}

.alert button {
  position: relative !important;
  padding: 0 !important;
}

.Pcontent {
  background-color: #fff;
  width: 100%;
}
</style>